import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const popupContainer = css`
  ${flex('column', 'space-evenly')};
  width: 100%;
  height: inherit;
`;

export const buttonStyle = css`
  color: ${colors.PrimaryWhiteColor};
  width: 188px;
  height: 44px;
  ${ZeeFontBold(14, 18)};
`;

export const registerBtn = css`
  color: ${colors.PrimaryWhiteColor};
  width: 188px;
  height: 44px;
  ${ZeeFontBold(14, 18)};
  background-color: ${colors.AppBgColor};
  border: 1px solid ${colors.PrimaryWhiteColor};
`;

export const loginTextStyle = css`
  margin: 0px;
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontBold(16, 18)};
  ${MQ.MediaLg} {
    ${ZeeFontBold(24, 18)};
  }
`;

export const newUserText = css`
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontBold(14, 18)};
  margin: 0px;
  ${MQ.MediaLg} {
    ${ZeeFontBold(20, 18)};
  }
`;

export const lineBreakStyle = css`
  width: 100%;
  height: 0px;
  color: ${colors.PrimaryWhiteColor};
  opacity: 0.2;
`;

export const loginText = css`
  margin: 0px;
  ${ZeeFontRegular(12, 16)};
  ${MQ.MediaLg} {
    ${ZeeFontBold(20, 16)};
  }
`;
